import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/login");
      return;
    }
    api
      .post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then((res) => {
        setUser(res.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: res.data.user } });
      })
      .catch(() => navigate("/login"));
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0F17]" data-testid="auth-callback-loader">
      <div className="text-slate-400 font-mono text-sm uppercase tracking-[0.2em] animate-pulse">Connexion en cours...</div>
    </div>
  );
};
